import React, { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

interface I18nWrapperProps {
  children: React.ReactNode;
}

const I18nWrapper: React.FC<I18nWrapperProps> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Ensure i18n is initialized before rendering children
    const initI18n = async () => {
      await i18n.init();
      setIsInitialized(true);
    };

    initI18n();
  }, []);

  if (!isInitialized) {
    // Optional: Show a loading indicator while i18n initializes
    return <div className="loading">Loading...</div>;
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default I18nWrapper;
